// extracted by mini-css-extract-plugin
export default {"rank-user":"yHLYyHC0HlJozrwDJnRA","rankUser":"yHLYyHC0HlJozrwDJnRA"};